export default __webpack_public_path__ + "static/media/barclays6.fce32109.jpg";